var _circle, _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterIcon = function SvgTwitterIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 13.7988C29.2563 14.125 28.4637 14.3412 27.6375 14.4462C28.4875 13.9388 29.1363 13.1412 29.4412 12.18C28.6488 12.6525 27.7738 12.9863 26.8412 13.1725C26.0887 12.3713 25.0162 11.875 23.8462 11.875C21.5763 11.875 19.7487 13.7175 19.7487 15.9763C19.7487 16.3012 19.7762 16.6137 19.8438 16.9112C16.435 16.745 13.4188 15.1113 11.3925 12.6225C11.0387 13.2363 10.8313 13.9388 10.8313 14.695C10.8313 16.115 11.5625 17.3737 12.6525 18.1025C11.9937 18.09 11.3475 17.8988 10.8 17.5975C10.8 17.61 10.8 17.6262 10.8 17.6425C10.8 19.635 12.2212 21.29 14.085 21.6712C13.7512 21.7625 13.3875 21.8062 13.01 21.8062C12.7475 21.8062 12.4825 21.7913 12.2337 21.7362C12.765 23.36 14.2725 24.5538 16.065 24.5925C14.67 25.6838 12.8988 26.3412 10.9813 26.3412C10.645 26.3412 10.3225 26.3263 10 26.285C11.8162 27.4563 13.9688 28.125 16.29 28.125C23.835 28.125 27.96 21.875 27.96 16.4575C27.96 16.2762 27.9538 16.1013 27.945 15.9275C28.7588 15.35 29.4425 14.6288 30 13.7988Z",
    fill: "#312F30"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter_icon.c40605b4.svg";
export { ForwardRef as ReactComponent };